(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/utils/utils.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/utils/utils.js');
"use strict";

let bgClass;
const {
  cdn2
} = svs.core.config.data.svsconfig;
const classListCache = {};
const branding = svs.tickets.data.templateConfig.branding;
const {
  mapProductType
} = svs.ticketgames.ticketMappings.productMappings;
const setTabIndexItemsMenuNav = (nav, remove) => {
  const itemsMenuNav = nav && nav.getElementsByClassName('js-items-menu-nav')[0].childNodes;
  itemsMenuNav && itemsMenuNav.forEach(e => {
    e.tabIndex = remove ? -1 : 0;
  });
};
const setTabIndexOnButton = (button, remove) => {
  if (button) {
    button.tabIndex = remove ? -1 : 0;
  }
};
const onBreakPointChange = () => {
  if (svs.core.detect.breakpoint.greaterThan('md')) {
    hideHeader();
    showTopHeader();
  } else {
    hideTopHeader();
  }
};
const hideHeader = function () {
  let topContentHeight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  const nav = document.querySelector('.items-menu-wrapper');
  const gameNav = document.querySelector('.games-navigation-wrapper');
  const content = document.querySelector('.game-container');
  const heightDiff = nav.clientHeight + gameNav.clientHeight + topContentHeight;
  gsap.to(nav, 1, {
    y: -heightDiff
  });
  gsap.to(gameNav, 1, {
    y: -heightDiff,
    onComplete: () => {
      setTabIndexItemsMenuNav(nav, true);
      setTabIndexItemsMenuNav(gameNav, true);
    }
  });
  content && gsap.to(content, 1, {
    y: -heightDiff,
    marginBottom: -heightDiff
  });
};
const hideTopHeader = () => {
  const reactContainer = document.querySelector('.js-react-container');
  const fixedTopContent = document.querySelector('.js-fixed-top-content');
  const aoBrand = document.querySelector('.corporate-info-ao-brand');
  const profileIconButton = document.querySelector('.js-nav-user');
  const navHamburgerButton = document.querySelector('.js-nav-hamburger');
  const topContent = document.querySelector('#top-content');
  const heightDiff = topContent.clientHeight;
  hideHeader(topContent.clientHeight);
  gsap.to(aoBrand, 1, {
    y: -heightDiff
  });
  gsap.to(topContent, 1, {
    y: -heightDiff
  });
  gsap.to(navHamburgerButton, 1, {
    y: -heightDiff,
    onComplete: () => {
      setTabIndexOnButton(navHamburgerButton, true);
    }
  });
  gsap.to(profileIconButton, 1, {
    y: -heightDiff,
    onComplete: () => {
      setTabIndexOnButton(profileIconButton, true);
    }
  });
  fixedTopContent.style.height = null;
  reactContainer.style.minHeight = "calc(100vh - ".concat(fixedTopContent.clientHeight + heightDiff, "px)");
  fixedTopContent.style.height = "".concat(fixedTopContent.clientHeight - heightDiff, "px");
};
const showHeader = () => {
  const nav = document.querySelector('.items-menu-wrapper');
  const gameNav = document.querySelector('.games-navigation-wrapper');
  const container = document.querySelector('.game-container');
  gsap.to(nav, {
    duration: 1,
    y: 0
  });
  gsap.to(gameNav, {
    duration: 1,
    y: 0,
    onComplete: () => {
      setTabIndexItemsMenuNav(nav, false);
      setTabIndexItemsMenuNav(gameNav, false);
    }
  });
  container && gsap.to(container, {
    duration: 1,
    height: '100%'
  });
  gsap.to(container, {
    duration: 1,
    y: 0
  });
  gsap.to(container, {
    duration: 1,
    marginBottom: 0
  });
};
const showTopHeader = gameFinished => {
  const reactContainer = document.querySelector('.js-react-container');
  const fixedTopContent = document.querySelector('.js-fixed-top-content');
  const aoBrand = document.querySelector('.corporate-info-ao-brand');
  const profileIconButton = document.querySelector('.js-nav-user');
  const navHamburgerButton = document.querySelector('.js-nav-hamburger');
  const topContent = document.querySelector('#top-content');
  const heightDiff = topContent.clientHeight;
  gsap.to(topContent, {
    duration: 1,
    y: 0
  });
  gsap.to(aoBrand, 1, {
    y: 0
  });
  gsap.to(navHamburgerButton, {
    duration: 1,
    y: 0,
    onComplete: () => {
      setTabIndexOnButton(navHamburgerButton, false);
    }
  });
  gsap.to(profileIconButton, {
    duration: 1,
    y: 0,
    onComplete: () => {
      setTabIndexOnButton(profileIconButton, false);
    }
  });
  fixedTopContent.style.height = null;
  if (gameFinished) {
    var _getComputedStyle;
    const contentHeight = (_getComputedStyle = getComputedStyle(document.body)) === null || _getComputedStyle === void 0 ? void 0 : _getComputedStyle.getPropertyValue('--availableContentHeight');
    reactContainer.style.minHeight = contentHeight;
    return;
  }
  reactContainer.style.minHeight = "calc(100vh - ".concat(fixedTopContent.clientHeight + heightDiff, "px)");
};
setGlobal('svs.tickets.play.utils.utils', {
  selectSnappedElement: (element, className) => {
    if (!classListCache[className]) {
      classListCache[className] = document.getElementsByClassName(className);
    }
    const classList = classListCache[className];
    const classDistance = classList && classList.length > 1 ? classList[1].offsetLeft - classList[0].offsetLeft : 1;
    const leftScroll = element.scrollLeft || 1;
    const count = Math.round(leftScroll / classDistance);
    if (leftScroll < 2) {
      return classList[0];
    }
    return classList[count];
  },
  setMainContentBg: ticketInfo => {
    let className;
    if (ticketInfo !== null && ticketInfo !== void 0 && ticketInfo.customBg) {
      className = ticketInfo.customBg.url;
    } else {
      className = branding === 'triss' ? 'bg-triss-200' : "bg-skrapspel-".concat(mapProductType(ticketInfo.type));
    }
    svs.tickets.play.utils.utils.setAnimatedBg(ticketInfo.type);
    if (className !== bgClass) {
      const content = document.querySelector('.js-main-content');
      if (className.indexOf('images') + 1) {
        const formatedImgString = className.replace('{width}', 1920);
        content.style.backgroundImage = "url(".concat(cdn2 + formatedImgString, ")");
        content.style.backgroundSize = 'cover';
      } else {
        content.style.backgroundImage = '';
        content.style.backgroundSize = '';
        content.classList.add(className);
      }
      content.classList.remove(bgClass);
      bgClass = className;
    }
  },
  getTicketInfo: (ticketType, ticketConfigs) => _.find(ticketConfigs, product => product.type.toLowerCase() === (ticketType === null || ticketType === void 0 ? void 0 : ticketType.toLowerCase())) || {
    isNotConfigured: true
  },
  getMenuProduct: (ticketType, products) => _.find(products, product => {
    var _product$alternativeU;
    return ((_product$alternativeU = product.alternativeUrl) === null || _product$alternativeU === void 0 ? void 0 : _product$alternativeU.toLowerCase()) === (ticketType === null || ticketType === void 0 ? void 0 : ticketType.toLowerCase()) || product.type.toLowerCase() === (ticketType === null || ticketType === void 0 ? void 0 : ticketType.toLowerCase());
  }) || {
    isNotInLobby: true
  },
  hideFooter: () => {
    document.querySelector('.page-footer').classList.add('hide-page-footer');
  },
  showFooter: () => {
    document.querySelector('.page-footer').classList.remove('hide-page-footer');
  },
  hideHeaders: shouldHideTopHeader => {
    if (shouldHideTopHeader) {
      onBreakPointChange();
      svs.core.detect.breakpoint.on('change', onBreakPointChange);
    } else {
      hideHeader();
    }
  },
  showHeaders: function () {
    let shouldShowTopHeader = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    svs.core.detect.breakpoint.off('change', onBreakPointChange);
    showHeader();
    if (shouldShowTopHeader) {
      showTopHeader(true);
    }
  },
  getTicketVariations: ticketInfo => {
    const {
      variations
    } = ticketInfo;
    if (variations) {
      return parseInt(variations, 10);
    }
    return 0;
  },
  getSelectedTicketVariation: (selectedNumber, ticketInfo) => {
    const skinVariations = svs.tickets.play.utils.utils.getTicketVariations(ticketInfo);
    if (skinVariations) {
      return (selectedNumber - 1) % parseInt(skinVariations, 10) + 1;
    }
    return 0;
  },
  scrollTopContent: () => {
    $('html').animate({
      scrollTop: 0
    }, 250);
  },
  stashTicket: nb => {
    svs.components.Storage.browser.set('ticketNb', 'tickets', nb);
  },
  getTicketStash: () => svs.components.Storage.browser.get('ticketNb', 'tickets'),
  clearTicketStash: () => {
    svs.components.Storage.browser.remove('ticketNb', 'tickets');
  },
  setAnimatedBg: ticketType => {
    const BubbleBackground = svs.tickets.play.components.BubbleBackground;
    const container = document.getElementById('animatedBackgroundContainer');
    if (container) {
      if (ticketType.indexOf('pacman') + 1) {
        svs.tickets.play.components.pacmanBackground(container);
      } else {
        ReactDOM.render( React.createElement(BubbleBackground, {
          ticketType: ticketType
        }), container);
      }
    }
  },
  getTicketTypeFromWager: wagerId => {
    let game;
    if (wagerId === 'pagaende') {
      game = svs.tickets.data.fetchedGames[0];
    } else {
      game = svs.tickets.data.fetchedGame;
    }
    return {
      ticketType: game.properties.externalProductCode,
      wagerId: game.properties.externalWagerId,
      gameIsCompleted: game.completed
    };
  },
  getSwishTicketInfo: (availableTickets, ticketsConfig) => {
    var _availableTickets$fin;
    const swishTicketType = (_availableTickets$fin = availableTickets.find(ticket => ticket === null || ticket === void 0 ? void 0 : ticket.swishTicket)) === null || _availableTickets$fin === void 0 ? void 0 : _availableTickets$fin.type;
    if (!swishTicketType) {
      return null;
    }
    return ticketsConfig.find(ticket => ticket.type === swishTicketType && ticket.open);
  }
});

 })(window);